<p-dialog
  [visible]="visible()"
  (onHide)="hide()"
  header="Create New Watchlist"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '450px' }"
>
  <div class="space-y-4">
    <!-- Name Input -->
    <div class="form-field">
      <label for="watchlist-name" class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
        Watchlist Name <span class="text-red-500">*</span>
      </label>
      <input
        pInputText
        id="watchlist-name"
        type="text"
        [value]="name()"
        (input)="onNameChange($event)"
        placeholder="e.g., Tech Stocks, Dividend Stocks"
        class="w-full"
        [disabled]="isLoading()"
      />
    </div>

    <!-- Description Input -->
    <div class="form-field">
      <label for="watchlist-description" class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
        Description (Optional)
      </label>
      <textarea
        pInputTextarea
        id="watchlist-description"
        [value]="description()"
        (input)="onDescriptionChange($event)"
        placeholder="Brief description of this watchlist"
        rows="3"
        class="w-full"
        [disabled]="isLoading()"
      ></textarea>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <p-button
      label="Cancel"
      (onClick)="hide()"
      severity="secondary"
      [outlined]="true"
      [disabled]="isLoading()"
    ></p-button>
    <p-button
      label="Create"
      icon="pi pi-check"
      (onClick)="createWatchlist()"
      [loading]="isLoading()"
      [disabled]="!isFormValid()"
    ></p-button>
  </ng-template>
</p-dialog>
